import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';

/**
 * Formats a subscription price for display.
 *
 * Wire amounts are MINOR units, and for an annual price that is the FULL YEAR's amount - never a
 * per-month figure. This is the only place the minor-unit conversion happens, so no render site
 * hand-rolls `/ 100`.
 *
 * Stripe returns currency codes lowercase ('gbp'). `Intl` canonicalises case so that is harmless
 * today; upper-casing here keeps one representation in play regardless.
 */
export function formatSubscriptionPrice(currency: string, minorUnits: number): string {
  return toDisplayCurrency((currency || '').toUpperCase(), minorUnits / 100);
}
